import { Icon } from "@fluentui/react"
import { toast } from "react-toastify"

export const TOAST_API = {
    async resolve<T>(promise: Promise<any>, successMessage = 'Saved changes' as strnumnil_t, errorMessage = null as strnumnil_t, loadingMessage = 'Saving changes' as strnumnil_t, { hideIndicator } = {} as { hideIndicator?: boolean }) {
        !hideIndicator && toast.loading(loadingMessage, { position: toast.POSITION.TOP_RIGHT })
        let error = null as null | undefined | any, data = null as null | undefined | any, list = null as null | undefined | any[], originalResponse = null as nul_undef_t | any
        ({ error, data, list, originalResponse } = await promise);
        if (!hideIndicator) {
            toast.dismiss()
            toast[error ? 'error' : 'success'](error ? errorMessage || error : successMessage, { position: toast.POSITION.BOTTOM_RIGHT })
        }
        return { error, data, list, originalResponse }
    },
    async copyLink(link: string, message = 'Copied link to clipboard') {
        window.navigator.clipboard
            .writeText(link)
            .then(() => toast.success(<>{message}</>,
                { hideProgressBar: true, autoClose: 500, icon: <Icon iconName="Copy" /> })
            );
    },
    async copyHtmlToClipboard(query: string) {
        // 1. Get element and its outer HTML
        const tableElement = document.querySelector(query) as HTMLElement;
        if (!tableElement) {
            toast.error("Data not found!");
            return;
        }

        const tableHtml = tableElement.outerHTML;
        const tableText = tableElement?.innerText ?? ''; // Plain text fallback

        try {
            // 2. Create blobs for both rich HTML formatting and plain text
            const htmlBlob = new Blob([tableHtml], { type: "text/html" });
            const textBlob = new Blob([tableText], { type: "text/plain" });

            // 3. Construct a ClipboardItem containing both formats
            const clipboardItem = new ClipboardItem({
                "text/html": htmlBlob,
                "text/plain": textBlob
            });

            // 4. Write to the system clipboard
            await navigator.clipboard.write([clipboardItem]);

            toast.success("Data successfully copied!");
        } catch (err) {
            console.error(err)
            toast.error("Failed to copy data: ");
        }
    }


}

